<template>
    <div class="p-10">
        <div class="row">
            <div class="col-12">
                <div class="card-body">
                    <h4 class="card-title">You are the buyer counterparty</h4>
                    <h5 class="card-subtitle">Open trade &amp; negotiate</h5>

                    <h2 class="font-medium m-t-40 m-b-0">{{offer.commodity}}</h2>
                    <span class="text-muted">{{offer.description}}</span>

                    <h2 class="font-medium m-t-40 m-b-0">{{offer.quantity | count}} {{offer.unit.symbol}}</h2>
                    <span class="text-muted">Available Quantity</span>

                    <h2 class="font-medium m-t-40 m-b-0">{{offer.unit_price | money}} / {{offer.unit.symbol}}</h2>
                    <span class="text-muted">Unit Price</span>

                    <div class="m-t-30 m-b-30">
                        <!--<button data-toggle="modal" v-on:click="showModal()" data-target="#myModal" class="btn btn-lg btn-stem text-white waves-effect waves-light">Open Trade</button>-->
                        <button data-toggle="modal" @click="openTrade()" class="btn btn-lg btn-success text-white waves-effect waves-light">Open Trade</button>
                    </div>
                </div>
                <div>
                    <hr>
                </div>
                <div class="card-body">
                    <h4 class="card-title"><i class="fa fa-lock"></i>&nbsp;Encrypted Negotiations</h4>
                    <blockquote>
                        Once you open a trade, messages are end-to-end encrypted so your privacy is protected. The only case where we can read your messages is if either party initiates a dispute.
                    </blockquote>
                </div>
            </div>
        </div>

        <!--Open Trade Modal-->
        <div id="myModal" class="modal fade show" v-bind:style="{ display: openTradeModal }" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title" id="myModalLabel">Modal Heading</h4>
                        <button type="button" class="close" v-on:click="closeModal()" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body">
                        <h4>Overflowing text to show scroll behavior</h4>
                        <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.</p>
                        <p>Aenean lacinia bibendum nulla sed consectetur. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus
                            auctor fringilla.</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" v-on:click="closeModal()" class="btn btn-stem text-white waves-effect" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "OfferSidebar",
        props: {
            offerid: String,
            offer: Object
        },
        data() {
            return {
                openTradeModal: false,
            };
        },
        methods: {
            showModal() {
                this.openTradeModal = 'block';
            },
            closeModal() {
                this.openTradeModal = 'none';
            },
            openTrade() {
                this.$http.post('/trades', {
                    offer_id: this.offer.offer_id,
                })
                .then(reply => {
                    this.$router.push({name: "viewtrade", params: {tradeid: reply.data.trade_id}});
                })
                .catch(err => {
                    console.log(err)
                });
            }
        }
    }
</script>

<style scoped>

</style>